import { render, staticRenderFns } from "./SupportPanel.vue?vue&type=template&id=0ce37608&scoped=true&"
import script from "./SupportPanel.vue?vue&type=script&lang=js&"
export * from "./SupportPanel.vue?vue&type=script&lang=js&"
import style0 from "./SupportPanel.vue?vue&type=style&index=0&id=0ce37608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce37608",
  null
  
)

export default component.exports